import {
  ForeignKeyComponent,
  ForeignKeyRenderer,
  ListDataSource,
  LoggerFactory,
  Required,
} from "../index";
import { Type, Validator } from "./Type";
import React, { useEffect } from "react";

const log = LoggerFactory.create("ForeignKeyField");

export interface ForeignKeyFieldOptions {
  dataSource: ListDataSource<{}, {}>;
  valueField: string;
  labelField: string | ((option: {}) => string);
  searchField?: string;
  /** Optional placeholder text */
  placeholder?: string;
  renderSelectedOptions?: (option: {}) => string;
  /** path for link to foreign key source view */
  routeDestination?: string;
  /** optional parameter name, added after route destination path ( default 'valueField' ) */
  routeDestinationField?: string;
  filter?: string;
  isMulti?: boolean;
  minWidth?: number;
}

export const ForeignKeyField = (
  options: ForeignKeyFieldOptions,
  ...validators: Validator[]
) => {
  const hasRequiredValidator = validators.indexOf(Required) !== -1;

  return new Type({
    // casting as any so ts wont panic on extra props...
    Component: DsReloader(options, ForeignKeyComponent) as any,
    PresentationComponent: DsReloader(options, ForeignKeyRenderer) as any,
    props: {
      clearable: !hasRequiredValidator,
      ...options,
    },
    validators,
  });
};

const noNeedToUpdateDataSources: ListDataSource<any, any>[] = [];
const DsReloader = (options: ForeignKeyFieldOptions, Component: any) => {
  // @ts-ignore
  options.dataSource.onEvent &&
    // @ts-ignore
    options.dataSource.onEvent("parentChanged", () => {
      log.debug(
        "parent change so I am removing ds from noNeedToUpdateDataSources list",
        options.dataSource
      );
      const idx = noNeedToUpdateDataSources.indexOf(options.dataSource);
      if (idx !== -1) {
        noNeedToUpdateDataSources.splice(idx, 1);
      }
    });

  return function WrapperComponent(props: any) {
    useEffect(() => {
      if (noNeedToUpdateDataSources.indexOf(options.dataSource) === -1) {
        log.debug(
          "dataSource is not on a noNeedToUpdateDataSources list so I am reloading it"
        );
        fetchSelectOptions(options);
        noNeedToUpdateDataSources.push(options.dataSource);
      } else {
        log.debug(
          "dataSource is on a noNeedToUpdateDataSources list so I am NOT reloading it"
        );
      }
    }, []);

    return <Component {...props} />;
  };
};

const fetchSelectOptions = (options: ForeignKeyFieldOptions) => {
  let sortField: string;
  if (options.labelField instanceof Function) {
    if (!options.searchField) {
      throw new Error("searchField is mandatory if labelField is a function");
    }
    sortField = options.searchField;
  } else {
    sortField = options.labelField;
  }

  return options.dataSource.findAll({
    filters: [],
    page: { pageSize: 1000, pageNumber: 0 },
    sort: {
      order: "asc",
      sort: sortField,
    },
  });
};

ForeignKeyField.noNeedToUpdateDataSources = noNeedToUpdateDataSources;
